import React from 'react'

const AddIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='25'
    viewBox='0 0 24 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M13.2 6.5H10.8V11.3H6V13.7H10.8V18.5H13.2V13.7H18V11.3H13.2V6.5ZM12 0.5C5.376 0.5 0 5.876 0 12.5C0 19.124 5.376 24.5 12 24.5C18.624 24.5 24 19.124 24 12.5C24 5.876 18.624 0.5 12 0.5ZM12 22.1C6.708 22.1 2.4 17.792 2.4 12.5C2.4 7.208 6.708 2.9 12 2.9C17.292 2.9 21.6 7.208 21.6 12.5C21.6 17.792 17.292 22.1 12 22.1Z'
      fill='currentColor'
    />
  </svg>
)

export default AddIcon
